import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '@core/utilities/auth.guard';
import { RedeploymentAuthorize } from '@core/utilities/redeployment-authorize.guard';
import { Permission } from '@core/literals/permission.literal';
import { CheckoutComponent } from './checkout/checkout.component';
import { Organizations } from '../../shared/literals/shared.literal';

const routes: Routes = [
  {
    path: 'Checkout',
    component: CheckoutComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.CreateOrders, undefined))]
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class CheckoutsRoutingModule {

}
